function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4 7.97a.941.941 0 00.298.726l.67.639c.043.041.09.079.139.111l4.45 4.263a1.08 1.08 0 001.476 0l.669-.638a.934.934 0 00.001-1.367L7.835 8l3.867-3.704a.934.934 0 000-1.367l-.67-.639a1.08 1.08 0 00-1.475.001L5.103 6.557a1.03 1.03 0 00-.135.108l-.67.64a.943.943 0 00-.297.665z",
  fill: "currentColor"
})));